/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Equipment_Place_UnknownInputs */

const en_us2_equipment_place_unknown = /** @type {(inputs: Equipment_Place_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That is not a place to train we know.`)
};

const pt_br2_equipment_place_unknown = /** @type {(inputs: Equipment_Place_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse não é um lugar de treino que conhecemos.`)
};

const es_419_equipment_place_unknown = /** @type {(inputs: Equipment_Place_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese no es un lugar de entrenamiento que conozcamos.`)
};

const pt_pt2_equipment_place_unknown = /** @type {(inputs: Equipment_Place_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse não é um local de treino que conheçamos.`)
};

const fr_fr2_equipment_place_unknown = /** @type {(inputs: Equipment_Place_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce lieu d'entraînement ne nous est pas connu.`)
};

const de_de2_equipment_place_unknown = /** @type {(inputs: Equipment_Place_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Trainingsort kennen wir nicht.`)
};

const it_it2_equipment_place_unknown = /** @type {(inputs: Equipment_Place_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è un luogo di allenamento che conosciamo.`)
};

/**
* | output |
* | --- |
* | "That is not a place to train we know." |
*
* @param {Equipment_Place_UnknownInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const equipment_place_unknown = /** @type {((inputs?: Equipment_Place_UnknownInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equipment_Place_UnknownInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_equipment_place_unknown(inputs)
	if (locale === "es-419") return es_419_equipment_place_unknown(inputs)
	if (locale === "pt-PT") return pt_pt2_equipment_place_unknown(inputs)
	if (locale === "fr-FR") return fr_fr2_equipment_place_unknown(inputs)
	if (locale === "de-DE") return de_de2_equipment_place_unknown(inputs)
	if (locale === "it-IT") return it_it2_equipment_place_unknown(inputs)
	return en_us2_equipment_place_unknown(inputs)
});
export { equipment_place_unknown as "equipment.place_unknown" }